
import {IPdfViewerService} from "@app/library/PdfViewer/service/pdfViewer.service";
import angular from "angular";

export interface IPdfViewer {
    init(): void;
}

class PdfViewer implements IPdfViewer {
    initialized: boolean;


    static $inject = ["PdfViewerService", "$sce", "$scope", "$interval", "$element"];

    constructor(
        private $_pdfViewerSvc: IPdfViewerService,
        private $sce : angular.ISCEService,
        private $scope : angular.IScope,
        private $interval : angular.IIntervalService,
        private $element : angular.IAugmentedJQuery
    ) {

    }

    init = (): void => {

    }
}

function direct(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/directive/organize/templates/organize.directive.html',
        replace: true,
        controller: PdfViewer,
        controllerAs: 'pdfVm',
        scope: true,
        bindToController: {
            'disableDownload': '@?disableDownload',
            'documentId': '@?documentId'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IPdfViewer): void => {
            controller.init();
        }
    }
}

angular.module('eCareVault.PdfViewer').directive('pdfOpener', direct);

